<template>
  <div>
    <v-btn @click="dialog = true"
      ><v-icon class="mr-2" color="blue">mdi-account-group-outline</v-icon>
      Positions</v-btn
    >
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card>
        <ModalHeader
          title="Positions"
          icon="mdi-window-maximize"
          @close="dialog = false"
        />
        <!-- add position card -->
        <v-card-text class="pa-4">
          <v-text-field
            label="Position Name"
            dense
            outlined
            v-model="position.name"
          ></v-text-field>
          <v-textarea
            label="Description"
            dense
            outlined
            v-model="position.description"
          ></v-textarea>
          <v-text-field
            label="Base Rate Per Day"
            dense
            outlined
            v-model="position.base_rate_per_day"
          ></v-text-field>
          <v-btn color="primary" @click="submit" :loading="loading"
            >Submit</v-btn
          >

          <v-text-field
            label="Search"
            v-model="search"
            prepend-icon="mdi-magnify "
          ></v-text-field>
          <!-- positions data table here -->
          <v-data-table
            :items="positions"
            :headers="[
              { text: 'Actions', value: 'actions', sortable: false },
              { text: 'ID', value: 'id' },
              { text: 'Name', value: 'name' },
              { text: 'Description', value: 'description' },
              { text: 'Base Rate Per Day', value: 'base_rate_per_day' },
            ]"
            dense
          >
            <template v-slot:item.actions="{ item }">
              <div class="d-flex">
                <!-- edit -->
                <v-btn icon color="warning" @click="editPosition(item)"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
                <v-btn icon color="red" @click="del(item)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                >
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- lazy components-->
    <edit-position-modal
      v-if="editDialog"
      :item="editItem"
      @close="editDialog = false"
    ></edit-position-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import editPositionModal from "./editPositionModal.vue";
export default {
  components: { editPositionModal },
  data() {
    return {
      editDialog: false,
      editItem: {},
      dialog: false,
      search: "",
      position: {},

      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      positions: "position/positions",
    }),
  },
  methods: {
    ...mapActions({
      delete_position: "position/delete_position",
      add_position: "position/add_position",
      get_positions: "position/get_positions",
    }),
    editPosition(item) {
      this.editItem = item;
      this.editDialog = true;
    },
    async del(item) {
      let x = await this.$confirm({
        title: "Delete Position",
        message: "Are you sure you want to delete this position?",
        color: "red",
        icon: "mdi-delete",
      });
      if (x) {
        this.loading = true;
        await this.delete_position(item);
        this.loading = false;
        this.$alert({
          title: "Success",
          message: "Successfully deleted a position",
          color: "success",
          icon: "mdi-check-circle",
        });
      }
    },
    async submit() {
      this.loading = true;
      try {
        this.add_position(this.position);
        this.$alert({
          title: "Success",
          message: "Position added successfully",
          color: "success",
          icon: "mdi-check-circle",
        });
      } catch (error) {
        this.$alert({
          title: "Error",
          message: "Error adding position",
          color: "error",
          icon: "mdi-alert-circle",
        });
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    // get positions
  },
  mounted() {
    if (this.positions.length === 0) {
      this.get_positions();
    }
  },
};
</script>

<style></style>
